import { render, staticRenderFns } from "./UnimpersonateButton.vue?vue&type=template&id=d80a0bb6&scoped=true&"
import script from "./UnimpersonateButton.vue?vue&type=script&lang=js&"
export * from "./UnimpersonateButton.vue?vue&type=script&lang=js&"
import style0 from "./UnimpersonateButton.vue?vue&type=style&index=0&id=d80a0bb6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80a0bb6",
  null
  
)

export default component.exports